import * as React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectSite = (to: string): JSX.Element => {
  return <Navigate to={to} />;
};

export default RedirectSite;
